import React, {
  ReactNode,
  createContext,
  useContext,
  useEffect,
  useState
} from 'react';

import { Storage } from '../utils/localStorage';
import axios from 'axios';

// Create a context with an initial value of null
declare const console: any;
declare const localStorage: any;

interface AppContextProps {
  isShowTaxEnabled: boolean;
  isShippingEnabled: boolean;
  isEncryptEnabled: boolean;
  isPrivacyOpen: boolean;
  coverage: any; 
  handleLocalSave: (key: string, data: any) => void;
  handleLocalDelete: () => void;
  setIsPrivacyOpen: (isOpen: boolean) => void;
  setCoverage: (coverage: any) => void;
}

export const AppContext = createContext<AppContextProps | null>(null);

// Provider component that wraps the part of the app that needs access to the cart state
export const AppProvider = ({ children }:  { children: ReactNode }) => {
  const [isEncryptEnabled, setIsEncryptEnabled] = useState(true);
  const [location, setLocation] = useState(null);
  const [isShippingEnabled, setIsShippingEnabled] = useState(false);
  const [isShowTaxEnabled, setIsShowTaxEnabled] = useState(false);
  // Exemplo de estado para abrir e fechar a modal de privacidade
  const [isPrivacyOpen, setIsPrivacyOpen] = useState(false);
  const [coverage, setCoverage] = useState(null);

  const handleLocalSave = async (key: string, data: any): Promise<void> => {
    // await Storage.saveItem(key, data);
  };

  const handleLocalDelete = async () => {
  }

  useEffect(() => {
    async function getLocation() {
      const response = await axios.get('https://extreme-ip-lookup.com/json/?key=IeclDqwBBmCh3oehL3VE');
      setLocation(response.data);
      localStorage.setItem('location', JSON.stringify(response.data));
    };
    getLocation();
    setIsEncryptEnabled(true)

  }, []);

  return (
    <AppContext.Provider
    value={{
      isShowTaxEnabled,
      isShippingEnabled,
      isEncryptEnabled,
      handleLocalSave,
      handleLocalDelete,
      isPrivacyOpen,
      setIsPrivacyOpen,
      coverage,
      setCoverage,
    }}
  >
      {children}
    </AppContext.Provider>
  );
};

// Custom hook to use the cart context
export const useApp = (): AppContextProps => {
  
  const context =  useContext(AppContext);
  if (!context) {
    throw new Error('useApp must be used within a AppProvider');
  }
  return context;

};


